import { useEffect } from 'react';
import { useWYSIWYGContext } from '../contexts/WYSIWYGContext';

export const useUndoManagerEffect = (contentLocale: string) => {
  const { htmlEditorRef } = useWYSIWYGContext();

  useEffect(() => {
    // when switching locales, reset the UndoManager (because the content will have been replaced
    // and the previous undo/redo levels will not be applicable to the new content)
    htmlEditorRef?.current?.undoManager.reset();
  }, [contentLocale]);
};
